import Box from "@material-ui/core/esm/Box";
import Check from "@material-ui/icons/esm/Check";
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import BadgeStep from 'components/BadgeStep/BadgeStep';
import SummaryPage from 'components/SummaryPage/SummaryPage';
import SummaryPageAds, { SummaryPageAdType } from 'components/SummaryPage/SummaryPageAds';
import { BoldSubtitle } from 'components/Text';
import { BILISTA_AD_LINK } from 'constants/urls';
import { registeredVehicle as registeredVehicleAtom } from 'state/vehicles';
import useStyles from './SummaryStyles';
export default function Summary() {
  const {
    t
  } = useTranslation();
  const vehicleData = useRecoilValue(registeredVehicleAtom);
  const {
    infoList
  } = useStyles();
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SummaryPage, {
    header: t('register_vehicle.thank_you')
  }, /*#__PURE__*/React.createElement(BadgeStep, {
    badgeContent: /*#__PURE__*/React.createElement(Check, null)
  }, /*#__PURE__*/React.createElement(BoldSubtitle, null, t('register_vehicle.tag_order_completed'))), /*#__PURE__*/React.createElement(Box, {
    className: infoList
  }, /*#__PURE__*/React.createElement(BoldSubtitle, null, t('register_vehicle.info_list.header')), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, t('register_vehicle.info_list.line1')), /*#__PURE__*/React.createElement("li", null, t('register_vehicle.info_list.line2')), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "register_vehicle.info_list.line3",
    components: {
      a: /*#__PURE__*/React.createElement("a", {
        href: BILISTA_AD_LINK,
        target: "_blank",
        rel: "noopener noreferrer"
      })
    }
  })))), /*#__PURE__*/React.createElement(SummaryPageAds, {
    type: SummaryPageAdType.REGISTER,
    lpn: vehicleData?.registrationNumber ?? ''
  })));
}